<div class="db-ai-builder-create-page-options__content">
  <h2 class="mb4">Add more pages to your website</h2>
  <p class="mb30">Choose how you want to add new pages from<br/> the options below:</p>

  <db-loading-screen *ngIf="loading"></db-loading-screen>
  <ng-container *ngFor="let
  option of options">
    <div class="option" [ngClass]="{'theme-disabled': !option.active}"
         (click)="onOptionChose.emit(option.slug)">
      <div class="option-desc">
        <h3 class="mb2" [innerHTML]="option?.title"></h3>
        <span [innerHTML]="option?.desc"></span>
      </div>
      <div class="arrow">
        <i class="db-icon db-icon-ds-arrow-small"></i>
      </div>
    </div>
    <div class="ds-notification-warning mb10" *ngIf="(!websiteTenWebTheme || !defaultThemes) && option.slug
     ===
    'blank'">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <span>Those options are not available with your current theme. <a
          (click)="installActivate()"
          class="db-theme-link">Install & activate</a> 10Web Builder theme to get access.</span>
      </div>
    </div>
  </ng-container>

</div>
<div class="ai-builder-create-page__image" *ngIf="!isMobile">
</div>
